import React, { useState } from 'react';
import { ShieldIcon, LockIcon, CreditCardIcon } from 'lucide-react';
interface CheckoutFormProps {
  subtotal: number;
  tax: number;
  total: number;
}
export function CheckoutForm({
  subtotal,
  tax,
  total
}: CheckoutFormProps) {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    address: '',
    city: '',
    postalCode: '',
    country: 'Germany',
    cardNumber: '',
    expiryDate: '',
    cvc: ''
  });
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle form submission
    console.log('Order placed', formData);
    alert('Thank you for your order! (This is a demo)');
  };
  const countries = ['Austria', 'Belgium', 'Bulgaria', 'Croatia', 'Cyprus', 'Czech Republic', 'Denmark', 'Estonia', 'Finland', 'France', 'Germany', 'Greece', 'Hungary', 'Ireland', 'Italy', 'Latvia', 'Lithuania', 'Luxembourg', 'Malta', 'Netherlands', 'Poland', 'Portugal', 'Romania', 'Slovakia', 'Slovenia', 'Spain', 'Sweden'];
  return <form onSubmit={handleSubmit} className="bg-white rounded-lg shadow-lg p-6" data-id="element-9">
      {/* Customer Information */}
      <div className="mb-8" data-id="element-10">
        <h2 className="text-xl font-semibold mb-4" data-id="element-11">Customer Information</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-12">
          <div data-id="element-13">
            <label htmlFor="firstName" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-14">
              First Name
            </label>
            <input type="text" id="firstName" name="firstName" value={formData.firstName} onChange={handleChange} required className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500" data-id="element-15" />
          </div>
          <div data-id="element-16">
            <label htmlFor="lastName" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-17">
              Last Name
            </label>
            <input type="text" id="lastName" name="lastName" value={formData.lastName} onChange={handleChange} required className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500" data-id="element-18" />
          </div>
          <div data-id="element-19">
            <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-20">
              Email
            </label>
            <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500" data-id="element-21" />
          </div>
          <div data-id="element-22">
            <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-23">
              Phone
            </label>
            <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} required className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500" data-id="element-24" />
          </div>
        </div>
      </div>
      {/* Shipping Address */}
      <div className="mb-8" data-id="element-25">
        <h2 className="text-xl font-semibold mb-4" data-id="element-26">Shipping Address</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-27">
          <div className="md:col-span-2" data-id="element-28">
            <label htmlFor="address" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-29">
              Street Address
            </label>
            <input type="text" id="address" name="address" value={formData.address} onChange={handleChange} required className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500" data-id="element-30" />
          </div>
          <div data-id="element-31">
            <label htmlFor="city" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-32">
              City
            </label>
            <input type="text" id="city" name="city" value={formData.city} onChange={handleChange} required className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500" data-id="element-33" />
          </div>
          <div data-id="element-34">
            <label htmlFor="postalCode" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-35">
              Postal Code
            </label>
            <input type="text" id="postalCode" name="postalCode" value={formData.postalCode} onChange={handleChange} required className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500" data-id="element-36" />
          </div>
          <div className="md:col-span-2" data-id="element-37">
            <label htmlFor="country" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-38">
              Country
            </label>
            <select id="country" name="country" value={formData.country} onChange={handleChange} required className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500" data-id="element-39">
              {countries.map(country => <option key={country} value={country} data-id="element-40">
                  {country}
                </option>)}
            </select>
          </div>
        </div>
      </div>
      {/* Payment Details */}
      <div className="mb-8" data-id="element-41">
        <div className="flex items-center justify-between mb-4" data-id="element-42">
          <h2 className="text-xl font-semibold" data-id="element-43">Payment Details</h2>
          <div className="flex items-center space-x-2" data-id="element-44">
            <ShieldIcon className="h-5 w-5 text-green-600" data-id="element-45" />
            <span className="text-sm text-green-600 font-medium" data-id="element-46">
              Secure Payment
            </span>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-47">
          <div className="md:col-span-2" data-id="element-48">
            <label htmlFor="cardNumber" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-49">
              Card Number
            </label>
            <div className="relative" data-id="element-50">
              <input type="text" id="cardNumber" name="cardNumber" value={formData.cardNumber} onChange={handleChange} placeholder="1234 5678 9012 3456" required className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 pl-10" data-id="element-51" />
              <CreditCardIcon className="absolute left-3 top-2.5 h-5 w-5 text-gray-400" data-id="element-52" />
            </div>
          </div>
          <div data-id="element-53">
            <label htmlFor="expiryDate" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-54">
              Expiry Date
            </label>
            <input type="text" id="expiryDate" name="expiryDate" value={formData.expiryDate} onChange={handleChange} placeholder="MM/YY" required className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500" data-id="element-55" />
          </div>
          <div data-id="element-56">
            <label htmlFor="cvc" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-57">
              CVC
            </label>
            <div className="relative" data-id="element-58">
              <input type="text" id="cvc" name="cvc" value={formData.cvc} onChange={handleChange} placeholder="123" required className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500" data-id="element-59" />
            </div>
          </div>
        </div>
        <div className="flex items-center mt-4" data-id="element-60">
          <LockIcon className="h-5 w-5 text-gray-500 mr-2" data-id="element-61" />
          <span className="text-sm text-gray-500" data-id="element-62">
            Your payment info is secured with 256-bit SSL encryption
          </span>
        </div>
      </div>
      {/* Order Total */}
      <div className="border-t border-gray-200 pt-4 mb-6" data-id="element-63">
        <div className="flex justify-between mb-2" data-id="element-64">
          <span data-id="element-65">Subtotal</span>
          <span data-id="element-66">€{subtotal.toFixed(2)}</span>
        </div>
        <div className="flex justify-between mb-2" data-id="element-67">
          <span data-id="element-68">VAT (21%)</span>
          <span data-id="element-69">€{tax.toFixed(2)}</span>
        </div>
        <div className="flex justify-between font-semibold text-lg" data-id="element-70">
          <span data-id="element-71">Total</span>
          <span data-id="element-72">€{total.toFixed(2)}</span>
        </div>
      </div>
      {/* Submit Button */}
      <button type="submit" className="w-full bg-indigo-600 hover:bg-indigo-700 text-white font-medium py-3 px-4 rounded-md transition-colors shadow-md flex items-center justify-center" data-id="element-73">
        <LockIcon className="h-5 w-5 mr-2" data-id="element-74" />
        Place Order
      </button>
    </form>;
}